import { api } from "../api";

export const generatePassword = async (): Promise<string> => {
  const response = await api.services.passwords.generatePassword();
  return response.data.password;
};
